import React from 'react'
import SingleBlog from './[id]'
// function SingleBlogDetails() {
//     return (
//       <div>{SingleBlog}</div>
//     )
//   }
  
  export default SingleBlog